import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { ILegalTransaction_has_LegalTransactionSpecialFunction } from '../../../Interfaces/ILegalTransaction_has_LegalTransactionSpecialFunction';
import { ILegalPhaseFullObject } from '../../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../../Interfaces/ILegalRequirementState';
import { IResult } from '../../DocumentDirectory/LandregisterSerachDialog';
import { useSelector } from 'react-redux';
import { State } from '../../../redux/mainReducer';
import { LandRegisterCheckEntry } from './LandRegisterCheckEntry';

interface IProps {
  idLegalTransaction: number;
  legalTransaction_has_LegalTransactionSpecialFunctionArray: ILegalTransaction_has_LegalTransactionSpecialFunction[];
  setLegalTransaction_has_LegalTransactionSpecialFunctionArray: Function;
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  legalReqState: ILegalRequirementState[];
  deleteSpecialFunction: Function;
}

interface IPayload {
  idDistrictCourt: null | number;
  idLandMarking: null | number;
  Court: null | string;
  Marking: null | string;
  SearchString: null | string;
  DownloadArray: IResult[];
}

export const LandRegisterCheck = ({
  idLegalTransaction,
  legalTransaction_has_LegalTransactionSpecialFunctionArray,
  setLegalTransaction_has_LegalTransactionSpecialFunctionArray,
  legalPhaseFullObjectArray,
  legalReqState,
  deleteSpecialFunction,
}: IProps) => {
  const districtCourtArray = useSelector(
    (state: State) => state.districtCourtArray.storeDistrictCourt
  );
  const landMarkingArray = useSelector(
    (state: State) => state.landMarkingArray.storeLandMarking
  );

  const initializePayloadArray = () => {
    return legalTransaction_has_LegalTransactionSpecialFunctionArray.map(
      item => {
        const districtCourt = districtCourtArray.find(
          dc => dc.Court === item.Function_Field4
        );
        const landMarking = landMarkingArray.find(
          lm => lm.LandMarking === item.Function_Field5
        );

        return {
          idDistrictCourt: districtCourt ? districtCourt.idDistrictCourt : null,
          idLandMarking: landMarking ? landMarking.idLandMarking : null,
          Court: item.Function_Field4 || null,
          Marking: item.Function_Field5 || null,
          SearchString: null,
          DownloadArray: [],
        };
      }
    );
  };

  const [payloadArray, setPayloadArray] = useState<IPayload[]>(
    initializePayloadArray
  );

  const handleChange = (index: number, field: string, value: string) => {
    const updatedArray =
      legalTransaction_has_LegalTransactionSpecialFunctionArray.map(
        (item, i) => {
          if (item.idSF === 4 && i === index) {
            const updatedItem = { ...item, [field]: value };
            updatedItem.Function_Field3 = '1';
            return updatedItem;
          }
          return item;
        }
      );
    setLegalTransaction_has_LegalTransactionSpecialFunctionArray(updatedArray);
  };

  const handlePayloadChange = (
    index: number,
    updatedPayload: Partial<IPayload>
  ) => {
    const updatedPayloadArray = [...payloadArray];
    updatedPayloadArray[index] = {
      ...updatedPayloadArray[index],
      ...updatedPayload,
    };
    setPayloadArray(updatedPayloadArray);
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <Typography variant='h5'>
          Grundbuch Nachverfolgung und Markentabellennachverfolgung
        </Typography>
      </Grid>

      {legalTransaction_has_LegalTransactionSpecialFunctionArray.map(
        (specialFunction, index) => (
          <LandRegisterCheckEntry
            key={`landregister-check-${specialFunction.idLegalTransaction_has_LegalTransactionSpecialFunction}`}
            currentSpecialFunction={specialFunction}
            deleteSpecialFunction={deleteSpecialFunction}
            idLegalTransaction={idLegalTransaction}
            legalPhaseFullObjectArray={legalPhaseFullObjectArray}
            legalReqState={legalReqState}
            legalTransaction_has_LegalTransactionSpecialFunctionArray={
              legalTransaction_has_LegalTransactionSpecialFunctionArray
            }
            setLegalTransaction_has_LegalTransactionSpecialFunctionArray={
              setLegalTransaction_has_LegalTransactionSpecialFunctionArray
            }
          />
        )
      )}
    </Grid>
  );
};
